"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="173798" id="teethwhitening" className="relative w-full min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden">
            {}
            <div className="absolute inset-0 z-0">
                <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5154-2-scaled.jpg" alt="Lüks diş beyazlatma tedavisi ve ışıltılı gülüş" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-background/80 backdrop-blur-[2px]" />
            </div>

            {}
            <div className="container mx-auto px-6 md:px-12 relative z-10">
                <div ref={ref} className={`max-w-3xl flex flex-col items-start gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                    <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-serif font-bold text-foreground leading-[1.1] tracking-tight">
                        Işıltılı Bir Gülüşe <br className="hidden sm:block" /> Güvenle Yolculuk
                    </h1>
                    
                    <p className="text-lg sm:text-xl md:text-2xl font-sans text-muted-foreground max-w-2xl leading-relaxed font-light">
                        Diş Hekimi Ayşegül İnneci Uzun kliniğinde, modern beyazlatma teknikleriyle diş minesine zarar vermeden hayalinizdeki bembeyaz ve doğal gülüşe kavuşun.
                    </p>
                    
                    <div className="pt-6 border-t border-primary/20 w-full max-w-xs">
                        <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-10 py-7 text-lg font-medium transition-transform duration-300 hover:scale-105 shadow-xl">
                            <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
                                Randevu Al
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>;
}